import $ from 'jquery';

function init() {
  cartClick()
  upsellClick()
  gallery()
  smoothScroll()
}

function smoothScroll() {
  $('.pdp a').not('[href="#"]').click(function(event) {
    event.preventDefault()
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      let target = $(this.hash)
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')

      if (target.length) {
        const offset = $('.header').outerHeight() + 30
        const scroll = target.offset().top - offset
        $('html, body').animate({
          scrollTop: scroll
        }, 1000, function() {
          var $target = $(target)
          $target.focus({ preventScroll: true })
          if ($target.is(":focus")) {
            return false
          } else {
            $target.attr('tabindex', '-1')
            $target.focus({ preventScroll: true })
          }
        })
      }
    }
  })
}

function cartClick() {
  $('.pdp-cart').click(function(e) {
    e.preventDefault()

    let variant = $(this).data('id')

    $.post('/cart/add.js', {
      quantity: 1,
      id: variant
    }).done(res => {
      const data = JSON.parse(res)
      cart.open = true
      $('.nav-cartQty').text(data.quantity).addClass('nav-cartQty--visible')
    }).fail(err => {
      console.error(err, 'error')
    })
  })
}

function upsellClick() {
  $('.upsellCard-add').click(function(e) {
    e.preventDefault()

    let variant = $(this).data('id')

    $.post('/cart/add.js', {
      quantity: 1,
      id: variant
    }).done(res => {
      $('.pdp-cart').click()
    }).fail(err => {
      console.error(err, 'error')
    })
  })
}

function gallery() {
  $('.pdp-galleryButton').click(function(e) {
    e.preventDefault()

    let index = $(this).data('index')

    $('.pdp-galleryImage').removeClass('pdp-galleryImage--active')
    $(this).find('.pdp-galleryImage').addClass('pdp-galleryImage--active')
    $(`.pdp-galleryMain .pdp-galleryImage[data-index="${index}"]`).addClass('pdp-galleryImage--active')
  })
}

$(document).ready(function () {
  init()
})
